import React from "react";
import { Modal } from "antd";
import { Col } from "react-bootstrap";

export const PortfolioModal = ({ modalOpen, setModalOpen, item }) => {
  return (
    <Modal
      centered
      open={modalOpen}
      onOk={setModalOpen}
      onCancel={setModalOpen}
      zIndex={99999}
      footer={null}
      width={1000}
    >
      <h3>{item?.title}</h3>
      <a href={item?.link} className="copy">
        {item?.link}
      </a>
      <Col className="aiCenter">
        <div className="pv20">
          <img className="portImg" src={item?.icon} />
        </div>
      </Col>
    </Modal>
  );
};
